import {createContext, Dispatch, FC, SetStateAction, useContext, useMemo, useState} from 'react'
import {
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  groupingOnSelectAll,
  ID,
} from '../../../../../_metronic/helpers'
import {useQueryResponse, useQueryResponseData} from './QueryResponseProviderCamera'
import {DeviceInfo} from './_models'

type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void

  itemIdForCamera: DeviceInfo
  setItemIdForCamera: Dispatch<SetStateAction<DeviceInfo>>
  isAllSelected: boolean
  disabled: boolean

  // selectedObject: DeviceInfo
  // setSelectedObject: Dispatch<SetStateAction<DeviceInfo>>

  itemIdForUpdateCamera?: string
  setItemIdForUpdateCamera: Dispatch<SetStateAction<string>>
  cityIdSelected?: string
  setCityIdSelected: Dispatch<SetStateAction<string>>
  itemIdForSettingLed?: string
  setItemIdForSettingLed: Dispatch<SetStateAction<string>>
}

const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  itemIdForCamera: {},
  setItemIdForCamera: () => {},

  isAllSelected: false,
  disabled: false,

  // selectedObject: {},
  // setSelectedObject: () => { },
  setItemIdForUpdateCamera: () => {},
  setItemIdForSettingLed: () => {},
  setCityIdSelected: () => {},
}

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProviderCamera: FC = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForCamera, setItemIdForCamera] = useState<DeviceInfo>(initialListView.itemIdForCamera)
  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  // const [selectedObject, setSelectedObject] = useState<DeviceInfo>(initialListView.selectedObject)
  const [itemIdForUpdateCamera, setItemIdForUpdateCamera] = useState<string>(
    initialListView.itemIdForUpdateCamera || ''
  )
  const [itemIdForSettingLed, setItemIdForSettingLed] = useState<string>(
    initialListView.itemIdForSettingLed || ''
  )
  const [cityIdSelected, setCityIdSelected] = useState<string>(initialListView.cityIdSelected || '')

  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForCamera,
        setItemIdForCamera,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },

        // selectedObject,
        // setSelectedObject,
        itemIdForUpdateCamera,
        setItemIdForUpdateCamera,
        itemIdForSettingLed,
        setItemIdForSettingLed,
        cityIdSelected,
        setCityIdSelected,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListViewCamera = () => useContext(ListViewContext)

export {ListViewProviderCamera, useListViewCamera}
